import logo from 'assets/integrations/github/icon-24.png'

import NavigatableIntegrationWidgetCard from '../NavigatableIntegrationWidgetCard'
import LinkedGitHubIssuesIndex from './LinkedGitHubIssuesIndex'
import LinkedGitHubIssue from './LinkedGitHubIssue'

export default function GitHubWidgetCard() {
  return (
    <NavigatableIntegrationWidgetCard
      detailComponent={LinkedGitHubIssue}
      image={logo}
      indexComponent={LinkedGitHubIssuesIndex}
      title="GitHub"
      persistenceKey="github"
    />
  )
}
